/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-const */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Group, Table as MantineTable } from '@mantine/core';
import { ReactNode } from 'react';
import { TipoCodigo } from '../../../../business/events/general';
import { EventBasicSearchResponseType } from '../../../../models/core/events.type';
import { formatCurrency, formatDateToString } from '../../../../utils/formatter.utils';

type DataViewProps = {
  data: EventBasicSearchResponseType[];
};

export default function Summary(props: DataViewProps) {
  const buildColeta = () => {
    const nodes: ReactNode[] = [];

    for (const evento of props.data) {
      let { residuo, veiculo, veiculoCompartilhado, tratamento, destinoFinal, cliente } =
        evento.resumoJSON || {};

      veiculo = veiculoCompartilhado ?? veiculo;
      residuo = residuo!;
      cliente = cliente!;

      nodes.push(
        <MantineTable.Tr key={`coleta_${evento.idEvento || formatDateToString(evento.data)}`}>
          <MantineTable.Td>
            {residuo.cliente.clienteNomeFantasia ||
              residuo.cliente.clienteRazaoSocial ||
              residuo.cliente.clienteNome}
          </MantineTable.Td>
          <MantineTable.Td>{`${residuo.local.logradouro}, ${residuo.local.numero}${
            residuo.local.complemento ? ` - ${residuo.local.complemento}` : ''
          } | ${residuo.local.bairro} - ${residuo.local.cidade} / ${residuo.local.codigoEstado} (${
            residuo.local.cep
          })`}</MantineTable.Td>
          <MantineTable.Td>{residuo.residuoCliente}</MantineTable.Td>
          <MantineTable.Td>{formatDateToString(evento.data)}</MantineTable.Td>

          <MantineTable.Td>
            <Group gap={2}>
              <div>
                {veiculo?.residuoVeiculo
                  ? `${veiculo?.residuoVeiculo}${
                      evento.idEventoVeiculoCompartilhado ? ` (F${evento.idEventoVeiculoCompartilhado})` : ''
                    }`
                  : '-'}
              </div>
            </Group>
          </MantineTable.Td>
          <MantineTable.Td>
            {veiculo?.cotacao.fornecedorNomeFantasia ||
              veiculo?.cotacao.fornecedorRazaoSocial ||
              veiculo?.cotacao.fornecedorNome ||
              '-'}
          </MantineTable.Td>
          <MantineTable.Td>
            {veiculo?.acondicionamentos && veiculo?.acondicionamentos?.length > 0 ? (
              <div>
                {veiculo?.acondicionamentos.map((y, index) => {
                  return (
                    <div
                      key={`coleta_acond_${evento.idEvento || 'tmp'}_${y.idResiduoAcondicionamento || index}`}
                    >{`(${y.enviar ? 'E' : 'R'}) ${y.residuoAcondicionamento} (${y.quantidade})`}</div>
                    // <div>{`${y.enviar ? 'Enviar' : 'Retirar'} ${y.quantidade} ${
                    //   y.residuoAcondicionamento
                    // }`}</div>
                  );
                })}
              </div>
            ) : (
              <>-</>
            )}
          </MantineTable.Td>

          <MantineTable.Td>{tratamento?.residuoTratamento || '-'}</MantineTable.Td>
          <MantineTable.Td>
            {tratamento?.cotacao.fornecedorNomeFantasia ||
              tratamento?.cotacao.fornecedorRazaoSocial ||
              tratamento?.cotacao.fornecedorNome ||
              '-'}
          </MantineTable.Td>

          <MantineTable.Td>{destinoFinal?.residuoDestinoFinal || '-'}</MantineTable.Td>
          <MantineTable.Td>
            {destinoFinal?.cotacao.fornecedorNomeFantasia ||
              destinoFinal?.cotacao.fornecedorRazaoSocial ||
              destinoFinal?.cotacao.fornecedorNome ||
              '-'}
          </MantineTable.Td>
        </MantineTable.Tr>
      );
    }

    return (
      <MantineTable className="custom-mantine-table" withTableBorder withColumnBorders>
        <MantineTable.Thead>
          <MantineTable.Tr>
            <MantineTable.Th colSpan={4}>Geral</MantineTable.Th>
            <MantineTable.Th colSpan={3}>Veículo</MantineTable.Th>
            <MantineTable.Th colSpan={2}>Tratamento</MantineTable.Th>
            <MantineTable.Th colSpan={2}>Destino Final</MantineTable.Th>
          </MantineTable.Tr>
          <MantineTable.Tr>
            <MantineTable.Th>Cliente</MantineTable.Th>
            <MantineTable.Th>Local</MantineTable.Th>
            <MantineTable.Th>Resíduo</MantineTable.Th>
            <MantineTable.Th>Data</MantineTable.Th>
            <MantineTable.Th>Observação</MantineTable.Th>

            <MantineTable.Th>Tipo</MantineTable.Th>
            <MantineTable.Th>Fornecedor</MantineTable.Th>
            <MantineTable.Th>Acondicionamento(s)</MantineTable.Th>

            <MantineTable.Th>Tipo</MantineTable.Th>
            <MantineTable.Th>Fornecedor</MantineTable.Th>

            <MantineTable.Th>Tipo</MantineTable.Th>
            <MantineTable.Th>Fornecedor</MantineTable.Th>
          </MantineTable.Tr>
        </MantineTable.Thead>
        <MantineTable.Tbody>{nodes}</MantineTable.Tbody>
      </MantineTable>
    );
  };

  const buildMobilizacao = () => {
    const nodes: ReactNode[] = [];

    for (const evento of props.data) {
      let { residuo, acondicionamento, equipamento, servico, cliente } = evento.resumoJSON || {};

      cliente = servico ? (servico?.cliente as any) : (residuo?.cliente as any) || cliente!;
      const local = servico ? servico?.local : residuo?.local || null;

      nodes.push(
        <MantineTable.Tr key={`mobilizacao_${evento.idEvento || formatDateToString(evento.data)}`}>
          <MantineTable.Td>
            {cliente?.clienteNomeFantasia || cliente?.clienteRazaoSocial || cliente?.clienteNome}
          </MantineTable.Td>
          <MantineTable.Td>
            {local
              ? `${local.logradouro}, ${local.numero}${
                  local.complemento ? ` - ${local.complemento}` : ''
                } | ${local.bairro} - ${local.cidade} / ${local.codigoEstado} (${local.cep})`
              : '-'}
          </MantineTable.Td>
          <MantineTable.Td>{residuo?.residuoCliente || servico?.servico}</MantineTable.Td>
          <MantineTable.Td>{formatDateToString(evento.data)}</MantineTable.Td>

          <MantineTable.Td>
            {evento.codigoEventoTipo === TipoCodigo.MobilizacaoEnviar ? 'Enviar' : 'Retirar'}
          </MantineTable.Td>
          <MantineTable.Td>
            {acondicionamento ? 'Acondicionamento' : equipamento ? 'Equipamento' : 'Prestador de Serviço'}
          </MantineTable.Td>
          <MantineTable.Td>
            {acondicionamento?.residuoAcondicionamento ||
              equipamento?.residuoEquipamento ||
              servico?.cotacao.fornecedorNomeFantasia ||
              servico?.cotacao.fornecedorRazaoSocial ||
              servico?.cotacao.fornecedorNome}
          </MantineTable.Td>
          <MantineTable.Td>
            {acondicionamento?.quantidade || equipamento?.quantidade || servico?.quantidade}
          </MantineTable.Td>
        </MantineTable.Tr>
      );
    }

    return (
      <MantineTable className="custom-mantine-table" withTableBorder withColumnBorders>
        <MantineTable.Thead>
          <MantineTable.Tr>
            <MantineTable.Th colSpan={4}>Geral</MantineTable.Th>
            <MantineTable.Th colSpan={4}>Produto/Serviço</MantineTable.Th>
          </MantineTable.Tr>
          <MantineTable.Tr>
            <MantineTable.Th>Cliente</MantineTable.Th>
            <MantineTable.Th>Local</MantineTable.Th>
            <MantineTable.Th>Resíduo / Serviço</MantineTable.Th>
            <MantineTable.Th>Data</MantineTable.Th>
            <MantineTable.Th>Observação</MantineTable.Th>

            <MantineTable.Th>Ação</MantineTable.Th>
            <MantineTable.Th>Tipo</MantineTable.Th>
            <MantineTable.Th>Item</MantineTable.Th>
            <MantineTable.Th>Quantidade</MantineTable.Th>
          </MantineTable.Tr>
        </MantineTable.Thead>
        <MantineTable.Tbody>{nodes}</MantineTable.Tbody>
      </MantineTable>
    );
  };

  const buildDocumentacao = () => {
    const nodes: ReactNode[] = [];

    for (const evento of props.data) {
      let { cliente, documentacao } = evento.resumoJSON || {};
      cliente = cliente!;

      nodes.push(
        <MantineTable.Tr key={`documentacao_${evento.idEvento || formatDateToString(evento.data)}`}>
          <MantineTable.Td>
            {cliente.clienteNomeFantasia || cliente.clienteRazaoSocial || cliente.clienteNome}
          </MantineTable.Td>
          <MantineTable.Td>{cliente.contato.nome || '-'}</MantineTable.Td>
          <MantineTable.Td>{formatDateToString(evento.data)}</MantineTable.Td>

          <MantineTable.Td>{documentacao || '-'}</MantineTable.Td>
        </MantineTable.Tr>
      );
    }

    return (
      <MantineTable className="custom-mantine-table" withTableBorder withColumnBorders>
        <MantineTable.Thead>
          <MantineTable.Tr>
            <MantineTable.Th colSpan={3}>Geral</MantineTable.Th>
            <MantineTable.Th colSpan={1}>Documentação</MantineTable.Th>
          </MantineTable.Tr>
          <MantineTable.Tr>
            <MantineTable.Th>Cliente</MantineTable.Th>
            <MantineTable.Th>Contato</MantineTable.Th>
            <MantineTable.Th>Data</MantineTable.Th>
            <MantineTable.Th>Observação</MantineTable.Th>

            <MantineTable.Th>Item</MantineTable.Th>
          </MantineTable.Tr>
        </MantineTable.Thead>
        <MantineTable.Tbody>{nodes}</MantineTable.Tbody>
      </MantineTable>
    );
  };

  const buildFechamento = () => {
    const nodes: ReactNode[] = [];

    for (const evento of props.data) {
      let { cliente, entidade, faturamento } = evento.resumoJSON || {};
      cliente = cliente!;

      nodes.push(
        <MantineTable.Tr key={`fechamento_${evento.idEvento || formatDateToString(evento.data)}`}>
          <MantineTable.Td>{`Contrato (#${evento.idContrato})`}</MantineTable.Td>
          <MantineTable.Td>
            {cliente?.clienteNomeFantasia ||
              cliente?.clienteRazaoSocial ||
              cliente?.clienteNome ||
              entidade?.nomeFantasia ||
              entidade?.razaoSocial ||
              entidade?.nome}
          </MantineTable.Td>
          <MantineTable.Td>{formatDateToString(evento.data)}</MantineTable.Td>

          <MantineTable.Td>
            {faturamento
              ? `${formatDateToString(faturamento.dataInicial)} - ${formatDateToString(
                  faturamento.dataFinal
                )}`
              : '-'}
          </MantineTable.Td>
        </MantineTable.Tr>
      );
    }

    return (
      <MantineTable className="custom-mantine-table" withTableBorder withColumnBorders>
        <MantineTable.Thead>
          <MantineTable.Tr>
            <MantineTable.Th>Fonte</MantineTable.Th>
            <MantineTable.Th>Cliente</MantineTable.Th>
            <MantineTable.Th>Data do Fechamento</MantineTable.Th>
            <MantineTable.Th>Período de Referência</MantineTable.Th>
          </MantineTable.Tr>
        </MantineTable.Thead>
        <MantineTable.Tbody>{nodes}</MantineTable.Tbody>
      </MantineTable>
    );
  };

  const buildComissao = () => {
    const nodes: ReactNode[] = [];

    for (const evento of props.data) {
      let { comissao } = evento.resumoJSON || {};

      nodes.push(
        <MantineTable.Tr key={`comissao_${evento.idEvento || formatDateToString(evento.data)}`}>
          <MantineTable.Td>
            {evento.idContrato
              ? `Contrato (#${evento.idContrato})`
              : evento.idProposta
              ? `Proposta (#${evento.idProposta})`
              : evento.idEntidade
              ? `Entidade (#${evento.idEntidade})`
              : '-'}
          </MantineTable.Td>
          <MantineTable.Td>
            {comissao?.nomeFantasia || comissao?.razaoSocial || comissao?.nome}
          </MantineTable.Td>
          <MantineTable.Td>{comissao?.porcentagem ? `${comissao.porcentagem}%` : '-'}</MantineTable.Td>
          <MantineTable.Td>{comissao?.preco ? formatCurrency(comissao.preco || 0) : '-'}</MantineTable.Td>
          <MantineTable.Td>{comissao?.ocorrencia || '-'}</MantineTable.Td>
        </MantineTable.Tr>
      );
    }

    return (
      <MantineTable className="custom-mantine-table" withTableBorder withColumnBorders>
        <MantineTable.Thead>
          <MantineTable.Tr>
            <MantineTable.Th colSpan={2}>Geral</MantineTable.Th>
            <MantineTable.Th colSpan={3}>Referência</MantineTable.Th>
          </MantineTable.Tr>
          <MantineTable.Tr>
            <MantineTable.Th>Fonte</MantineTable.Th>
            <MantineTable.Th>Entidade</MantineTable.Th>
            <MantineTable.Th>Observação</MantineTable.Th>
            <MantineTable.Th>Porcentagem</MantineTable.Th>
            <MantineTable.Th>Preço</MantineTable.Th>
            <MantineTable.Th>Ocorrências</MantineTable.Th>
          </MantineTable.Tr>
        </MantineTable.Thead>
        <MantineTable.Tbody>{nodes}</MantineTable.Tbody>
      </MantineTable>
    );
  };

  const buildLembreteExpiracaoFechamento = () => {
    const nodes: ReactNode[] = [];

    for (const evento of props.data) {
      let { cliente, entidade, documento } = evento.resumoJSON || {};
      cliente = cliente!;

      nodes.push(
        <MantineTable.Tr key={`geral_${evento.idEvento || formatDateToString(evento.data)}`}>
          <MantineTable.Td>
            {evento.idContrato
              ? `Contrato (#${evento.idContrato})`
              : evento.idProposta
              ? `Proposta (#${evento.idProposta})`
              : evento.idEntidade
              ? `Entidade (#${evento.idEntidade})`
              : '-'}
          </MantineTable.Td>
          <MantineTable.Td>
            {cliente?.clienteNomeFantasia ||
              cliente?.clienteRazaoSocial ||
              cliente?.clienteNome ||
              entidade?.nomeFantasia ||
              entidade?.razaoSocial ||
              entidade?.nome}
          </MantineTable.Td>
          <MantineTable.Td>{formatDateToString(evento.data)}</MantineTable.Td>

          <MantineTable.Td>
            {documento ? documento.documentoTipo || documento.outroTipo : '-'}
          </MantineTable.Td>
        </MantineTable.Tr>
      );
    }

    return (
      <MantineTable className="custom-mantine-table" withTableBorder withColumnBorders>
        <MantineTable.Thead>
          <MantineTable.Tr>
            <MantineTable.Th colSpan={3}>Geral</MantineTable.Th>
            <MantineTable.Th colSpan={1}>Referência</MantineTable.Th>
          </MantineTable.Tr>
          <MantineTable.Tr>
            <MantineTable.Th>Fonte</MantineTable.Th>
            <MantineTable.Th>Cliente</MantineTable.Th>
            <MantineTable.Th>Data</MantineTable.Th>
            <MantineTable.Th>Observação</MantineTable.Th>

            <MantineTable.Th>Item</MantineTable.Th>
          </MantineTable.Tr>
        </MantineTable.Thead>
        <MantineTable.Tbody>{nodes}</MantineTable.Tbody>
      </MantineTable>
    );
  };

  const buildExpandableContentByEventoTipo = (): ReactNode => {
    const evento = props.data?.[0];

    switch (evento.codigoEventoTipo) {
      case TipoCodigo.Coleta:
        return buildColeta();
      case TipoCodigo.MobilizacaoEnviar:
      case TipoCodigo.MobilizacaoRetirar:
      case TipoCodigo.Cobranca:
        return buildMobilizacao();
      case TipoCodigo.Comissao:
        return buildComissao();
      case TipoCodigo.Documetacao:
        return buildDocumentacao();
      case TipoCodigo.Lembrete:
      case TipoCodigo.Expiracao:
        return buildLembreteExpiracaoFechamento();
      case TipoCodigo.Fechamento:
        return buildFechamento();
      default:
        return <></>;
    }
  };

  return <>{buildExpandableContentByEventoTipo()}</>;
}
